module.exports = __webpack_public_path__ + "media/images/Results-Cohort3_IAbNegative-3e73b9e01c57b5384491f8d64a9cb884.png";